import React, { PropTypes } from 'react';

import './style.scss';

const ForumThreadsList = props => {

  return (
    <div className="ForumThreadsList">
      {props.title &&
        <div className="head">
          <h1>{props.title}</h1>
        </div>}

      {props.children}
    </div>
  );
};

ForumThreadsList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  title: PropTypes.string
};


export default ForumThreadsList;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/ForumThreadsList/index.js
 **/